import { dispatchHomePage } from "./page/home";
import { dispatchPost } from "./page/post";
import { dispatchCareerPage } from "./page/career";
import { dispatchPostCategories } from "./page/postcategories";
import { dispatchPromotion } from "./page/promotion";
import { dispatchPromotionCategories } from "./page/promotioncategories";
import { dispatchEvent } from "./page/event";
import { dispatchCareerPosition } from "./page/careerpositions";
import { dispatchContactPage } from "./page/contact";
import { dispatchEventPage } from "./page/eventpage";
import { dispatchNewsPage } from "./page/newspage";
import { dispatchPromotionPage } from "./page/promotionpage";
import { dispatchOurshowPage } from "./page/ourshowpage";
import { dispatchHighlightshowPage } from "./page/highlightshowpage";
import { getProfile } from "./page/auth";

const initApp = () => {
  return async dispatch => {
    const listApi = [];
    listApi.push(dispatchHomePage(dispatch));
    listApi.push(dispatchPost(dispatch));
    listApi.push(dispatchCareerPage(dispatch));
    listApi.push(dispatchPostCategories(dispatch));
    listApi.push(dispatchPromotion(dispatch));
    listApi.push(dispatchPromotionCategories(dispatch));
    listApi.push(dispatchEvent(dispatch));
    listApi.push(dispatchCareerPosition(dispatch));
    listApi.push(dispatchContactPage(dispatch));
    listApi.push(dispatchEventPage(dispatch));
    listApi.push(dispatchNewsPage(dispatch));
    listApi.push(dispatchPromotionPage(dispatch));
    listApi.push(dispatchOurshowPage(dispatch));
    listApi.push(dispatchHighlightshowPage(dispatch));
    listApi.push(getProfile(dispatch));
    try {
      await Promise.all(listApi);
    } catch (err) {
      console.error("initApp err", err);
    }
  };
};

export { initApp };



// WEBPACK FOOTER //
// ./src/actions/index.js